
export const gotoSystem = (accountId: number): void => {
  const PWS_URL = process.env.REACT_APP_PWS_URL ?? 'http://localhost:3000';
  window.open(`${PWS_URL}/accounts/switch/${accountId}`);
};
